import React, { useState } from "react";
import NoItemFound from "../../Components/SiteComponants/NoItemFound";
import FakeTableComponent from "../../Components/FakeTableComponent/FakeTableComponent";
import { productDatas } from "./../../Datas/ProductDatas/ProductDatas";
import SectionHeader from "./../../Components/SectionHeader/SectionHeader";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteData } from "../../Contexts/SiteContext";
import MenuButton from "../../Components/SiteComponants/MenuButton";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import { TitleSetup } from "../../Datas/Functions/titleSetup";

const ProductList = (meta) => {
  // setting up title of this page
  TitleSetup({...meta});
  //********** */
  const [searchedText, setSearchedText] = useState("");
  const [selectedItem, setSelectedItem] = useState("id");
  const [datalist, setDatalist] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    setDatalist(productDatas);
  }, []);
  useEffect(() => {
    const newDatalist = productDatas.filter((data) =>
      data[selectedItem].toLowerCase().includes(searchedText.toLowerCase())
    );
    setDatalist(newDatalist);
  }, [searchedText, selectedItem]);
  const handleOptionClick = (option,id) => {
    console.log(`Selected option: ${option}`);
  };

  const column = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: "id",
    },
    {
      name: "NAME",
      selector: (row) => row.name,
      sortable: "name",
    },
    {
      name: "CATEGORY",
      selector: (row) => row.category,
      sortable: "category",
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex flex-wrap">
          <MenuButton text="Info">
            <ul className="cursor-pointer ">
              <li
                className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
                onClick={() =>
                  navigate("/products/" + row.id)
                }
              >
                <span>
                  <i className="fa fa-eye" aria-hidden="true"></i>
                </span>
                <span>Preview </span>
              </li>
              <li
                className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
                onClick={() => navigate("/dashboard/manage-product/"+ row.id)}
              >
                <span>
                  <i className="fa fa-edit" aria-hidden="true"></i>
                </span>
                <span>Manage </span>
              </li>
              <li
                className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
                onClick={() => handleOptionClick("delete", row.id)}
              >
                <span>
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </span>{" "}
                <span>Delete </span>
              </li>
            </ul>
          </MenuButton>
        </div>
      ),
    },
  ];
  const selectionOption = [
    {
      title: "ID",
      value: "id",
    },
    {
      title: "Name",
      value: "name",
    },
    {
      title: "Category",
      value: "category",
    },
  ];
  return (
    <div className="w-full mx-2 md:container md:mx-auto">
      <SectionHeader heading={"Product List"} />
      <BreadCrumbs texts={["Dashboard", "Product List"]} />
      <FakeTableComponent
        datalist={datalist}
        column={column}
        pagination
        tableScroll
        tableScrollHeight={"500px"}
        tableHeaderComponent={
          <h2 className="text-4xl text-center font-semibold">Product List</h2>
        }
        filterComponents={[
          <div className="border rounded-sm my-2 mx-3">
            <select
              className="px-3 py-2 h-full sm:w-auto w-full sm:border-r-2 sm:border-b-0 border-b focus:outline-0 "
              onChange={(e) => setSelectedItem(e.target.value)}
              defaultValue={selectedItem}
            >
              {selectionOption.map((opt, i) => (
                <option key={i} value={opt.value}>
                  Seacrh by {opt.title}
                </option>
              ))}
            </select>
            <input
              onChange={(e) => setSearchedText(e.target.value)}
              className="px-3 py-2 w-40 sm:w-52  focus:outline-0"
              placeholder={`Search...🔎`}
            />
          </div>,
        ]}
        nodataComponent={<NoItemFound msg={"No data found"} />}
      />
    </div>
  );
};

export default ProductList;
